/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Supplement_TitleInputs */

const en_us2_profile_editors_supplement_title = /** @type {(inputs: Profile_Editors_Supplement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you take a protein supplement?`)
};

const pt_br2_profile_editors_supplement_title = /** @type {(inputs: Profile_Editors_Supplement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você toma suplemento de proteína?`)
};

const es_419_profile_editors_supplement_title = /** @type {(inputs: Profile_Editors_Supplement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tomas algún suplemento de proteína?`)
};

const pt_pt2_profile_editors_supplement_title = /** @type {(inputs: Profile_Editors_Supplement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomas suplemento de proteína?`)
};

const fr_fr2_profile_editors_supplement_title = /** @type {(inputs: Profile_Editors_Supplement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prends-tu un complément de protéines ?`)
};

const de_de2_profile_editors_supplement_title = /** @type {(inputs: Profile_Editors_Supplement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimmst du ein Proteinpräparat?`)
};

const it_it2_profile_editors_supplement_title = /** @type {(inputs: Profile_Editors_Supplement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendi un integratore proteico?`)
};

/**
* | output |
* | --- |
* | "Do you take a protein supplement?" |
*
* @param {Profile_Editors_Supplement_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_supplement_title = /** @type {((inputs?: Profile_Editors_Supplement_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Supplement_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_supplement_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_supplement_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_supplement_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_supplement_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_supplement_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_supplement_title(inputs)
	return en_us2_profile_editors_supplement_title(inputs)
});
export { profile_editors_supplement_title as "profile-editors.supplement_title" }